"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Person = exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _linkList = babelHelpers.interopRequireDefault(require("./linkList"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _carousel = babelHelpers.interopRequireDefault(require("carousel"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var PeopleGroupBlock =
/*#__PURE__*/
function (_LinkListBlock) {
  babelHelpers.inherits(PeopleGroupBlock, _LinkListBlock);

  function PeopleGroupBlock() {
    babelHelpers.classCallCheck(this, PeopleGroupBlock);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PeopleGroupBlock).apply(this, arguments));
  }

  babelHelpers.createClass(PeopleGroupBlock, [{
    key: "getChildren",
    value: function getChildren() {
      if (this.displayMode == 'people') {
        var Node = this.asCarousel ? _carousel.default : "div";
        var props = {
          className: 'people-container'
        };
        if (Node === _carousel.default) props = {
          listClassName: props.className
        };
        return _react.default.createElement("div", {
          className: "inner-content"
        }, _react.default.createElement(Node, props, this.content.map(function (card) {
          return _react.default.createElement(Person, _extends({
            key: card.id
          }, card));
        })));
      }

      return babelHelpers.get(babelHelpers.getPrototypeOf(PeopleGroupBlock.prototype), "getChildren", this).call(this);
    }
  }]);
  return PeopleGroupBlock;
}(_linkList.default);

exports.default = PeopleGroupBlock;
var Person = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Person, _Component);

  function Person() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Person);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Person)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "name", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "title", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "link", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "photo", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "icons", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "location", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(Person, [{
    key: "render",
    value: function render() {
      var props = {
        className: 'person'
      };
      var Node = "div";

      if (this.link) {
        props.href = this.link;
        Node = "a";
      }

      return _react.default.createElement(Node, props, _react.default.createElement(_ProfileImageContainer.default, {
        className: "person-photo",
        noImageClassName: "initials",
        image: this.photo,
        name: this.name
      }), _react.default.createElement("div", {
        className: "person-info"
      }, _react.default.createElement("div", {
        className: "person-name"
      }, this.name, this.icons.length && _react.default.createElement("span", {
        className: "account-icon-list"
      }, this.icons.map(function (icon) {
        return _react.default.createElement("img", {
          key: icon.id,
          className: "account-icon",
          src: icon.icon,
          title: icon.title
        });
      }))), this.title && _react.default.createElement("div", {
        className: "person-title"
      }, this.title), this.location && _react.default.createElement("div", {
        className: "person-location"
      }, this.location)));
    }
  }]);
  return Person;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "name", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "photo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "icons", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "location", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.Person = Person;